import React, { useState, useEffect } from "react";
import Loading from "../../../Student/Reusablecomponents/Loading";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa";
import ScenarioQuestionformat from "../../../Student/Reusablecomponents/ScenarioQuestionformat";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { QuestionData } from "../../../Redux/Reducers/QBAdmin/EditQuestions";
import { ScenarioData } from "../../../Redux/Reducers/QBAdmin/Editscenario";
import DataTable from "../../../Student/Reusablecomponents/DataTable/DataTable";
import ScenarioDelete, {
  GetScenarioDetails,
} from "../../../ReusableComponents/CommonApis";
import notify from "../../../ReusableComponents/ToastifyAlerts";
import Search from "../../../ReusableComponents/Search";
import { CheckLanguage } from "../../../ReusableComponents/CommonFunctions";
import {
  ViewVerificationQStatus,
  QuestionDelete,
  GetQuestionDetails,
  GetScienceQuestionDetails,
  QuestionPreview,
  ViewQuestionStatus,
} from "../../../ReusableComponents/CommonApis";
import axiosInstance from "../../../ReusableComponents/Axios";
import { FaClockRotateLeft } from "react-icons/fa6";
const InputBasedQuestions = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const PagnatioNumber = useSelector((state) => state.PaginationNo);
  const [IBQuestions, SetIBQuestions] = useState(props.data);
  const [PageCount, SetPageCount] = useState(10);
  const [CPage, SetCPage] = useState(1);
  const [DMessage, SetDMessage] = useState();
  const [NSBased, SetNSBased] = useState(
    localStorage.getItem("IBQF") || props.SType || "SCDISQ"
  );
  const [StatusData, SetStatusData] = useState();
  const [QuestionsData, SetQuestionData] = useState();
  const [Load, SetLoad] = useState(false);
  const [SearchText, SetSearchText] = useState(NSBased === "NONSCDISQ" ? localStorage.getItem("SearchQINQId") || "" : localStorage.getItem("SearchSINQId") || "");

  useEffect(() => {
    const PNumber =
      PagnatioNumber?.Location === location.pathname &&
      PagnatioNumber?.TableName === NSBased &&
      PagnatioNumber?.PageNumber;
    if (SearchText?.length > 0) {
      GetFilterDetails();
    } else {

      if (!props.data && SelectLanguage) {
        if (NSBased === "SCDISQ") {
          GetQuestiuons(PNumber || CPage);
        } else {
          GetNONSQuestiuons(PNumber || CPage);
        }
      }
    }
  }, [PageCount, NSBased, DMessage, SelectLanguage]);

  const ScenarioBased = [
    {
      name: "Scenario ID",
      selector: "scenarioID",
      sortable: true,
      cell: (row) => (
        <div
          className="LinkStyles"
          onClick={() => AddEditScenario(row)}
          title="Edit Scenario"
        >
          {row.scenarioID}{" "}
        </div>
      ),
    },
    {
      name: "Scenario",
      selector: "scenarioName",
      sortable: true,
      cell: (row) => (
        <div className="ScenarioList">
          <ScenarioQuestionformat scenario={row.scenarioName} />{" "}
        </div>
      ),
    },
    {
      name: "Main Source",
      selector: "mainSourceLovId",
      sortable: true,
      cell: (row) => (
        <div>
          {row.mainSourceLovId === 3543
            ? "Text book based"
            : "Non-text book based"}{" "}
        </div>
      ),
    },
    {
      name: "Questions",
      cell: (row) => (
        <div
          className="dflex alignitems CPointer JCCenter"
          style={{ gap: "15px" }}
        >
          <div className="dflex alignitems" style={{ gap: "5px" }}>
            <FaRegEye
              title="View Questions in Scenario"
              onClick={() => NavigateQuestions(row)}
              style={{ color: "#624DE3" }}
            />
            ({row?.questionCount}){" "}
          </div>
          {!CheckLanguage(SelectLanguage)?.[1] && (
            <RiDeleteBin5Line
              title="Delete"
              style={{ color: "#FD3333" }}
              onClick={() => DeleteScenario(row)}
            />
          )}
        </div>
      ),
    },
  ];
  const AddEditScenario = (Row) => {
    if (SearchText?.length > 0) {
      localStorage.setItem("SearchSINQId", SearchText);
    }
    GetScenarioDetails(
      SelectLanguage,
      Row.scenarioID,
      dispatch,
      navigate,
      SetLoad,
      location
    );
  };
  const DeleteScenario = async (Row) => {
    if (Row.questionCount > 0) {
      notify(
        "Please delete all questions associated with the scenario before you could delete the scenario",
        "warning"
      );
    } else {
      if (window.confirm("Are you sure you want to delete the scenario ?")) {
        ScenarioDelete(Row.scenarioID, dispatch, GetQuestiuons(1));
      }
    }
  };

  const NavigateQuestions = (Row) => {
    dispatch(ScenarioData({ ScenarioDetails: Row }));
    navigate("/QBAdmin/QuestionBank/ScenarioQuestions", {
      state: { Tab: "INQ" },
    });
  };
  const HandleQuestionDetails = (Qid) => {
    if (SearchText?.length > 0) {
      localStorage.setItem("SearchQINQId", SearchText);
    }
    if (items.subjectId === "1") {
      GetQuestionDetails(
        SelectLanguage,
        Qid,
        dispatch,
        navigate,
        SetLoad,
        location,
        true
      );
    } else {
      GetScienceQuestionDetails(
        SelectLanguage,
        Qid,
        dispatch,
        navigate,
        SetLoad,
        location,
        true
      );
    }
  };
  const NONScenarioBased = [
    {
      name: "Question No(Id)",
      selector: "questionID",
      sortable: true,
      cell: (row) => (
        <div
          className="LinkStyles"
          title="Edit Question"
          onClick={() => HandleQuestionDetails(row.questionID)}
        >
          {row.questionID}{" "}
        </div>
      ),
    },
    {
      name: "Question",
      selector: "question",
      cell: (row) => (
        <div className="ScenarioList">
          <ScenarioQuestionformat scenario={row.question} />
        </div>
      ),
    },
    {
      name: "Answer(s)",
      selector: "answer",
      sortable: true,
      cell: (row) => (
        <div className="dflex">
          <ScenarioQuestionformat scenario={row.answer} />
        </div>
      ),
    },
    {
      name: "Question Verification Status",
      selector: "qbStatus",
      sortable: true,
      cell: (row) => (
        <div className="dflex flexd-column">
          <span>{row.qbStatus}</span>
          <span
            className="LinkStyles"
            style={{ textWrap: "nowrap" }}
            onClick={() => SetStatusData(row.questionID)}
          >
            {" "}
            View Status Log{" "}
          </span>
        </div>
      ),
    },
    {
      name: "Used/Unused - Mapped/UnMapped",
      selector: "qStatus",
      sortable: true,
    },
    ...(items?.subjectId === "1"
      ? [
        {
          name: "Original / Cloned",
          selector: "isClonedOrOriginal",
          sortable: true,
        },
      ]
      : []),

    {
      name: "Action",
      cell: (row) => (
        <div
          className="dflex CPointer alignitems"
          style={{ gap: "15px", justifyContent: "center" }}
        >
          <FaRegEye
            title="Preview"
            onClick={() =>{
               if (SearchText?.length > 0) {
      localStorage.setItem("SearchQINQId", SearchText);
    }
              QuestionPreview(row, dispatch, navigate, location, true)}
            }
          />{" "}
          {!CheckLanguage(SelectLanguage)?.[1] && (
            <RiDeleteBin5Line
              style={{ color: "#FD3333" }}
              onClick={() =>
                QuestionDelete(row.questionID, SetDMessage, dispatch)
              }
            />
          )}
          <span
            className="LinkStyles"
            style={{ textWrap: "nowrap" }}
            onClick={() => SetQuestionData(row.questionID)}
            title="View Question Activity Log"
          >
            <FaClockRotateLeft />
          </span>
        </div>
      ),
    },
  ];

  const GetNONSQuestiuons = async (PageNo) => {
    SetCPage(PageNo);
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/QuestionBank/GetNonScenarioQuestions?SubjectId=${items?.subjectId}&PageNo=${PageNo}&PageSize=${PageCount}&Filter=0&QBCategoryType=${NSBased}&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.questionID) {
          SetIBQuestions(res.data);
        } else {
          SetIBQuestions(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
        SetDMessage();
      })
      .catch((err) => console.log(err));
  };

  const GetQuestiuons = async (PageNo) => {
    SetCPage(PageNo);
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetScenariosBySubject?SubjectId=${items?.subjectId}&PageNo=${PageNo}&PageSize=${PageCount}&IsUsedOrMapped=0&QBCategoryType=${NSBased}&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.scenarioID) {
          SetIBQuestions(res.data);
        } else {
          SetIBQuestions(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  const IBAUQuestions = () => {
    dispatch(ScenarioData({ ScenarioDetails: "" }));
    localStorage.setItem("IBQF", NSBased);
    if (NSBased === "SCDISQ") {
      navigate("/QBAdmin/QuestionBank/AddEditScenario", {
        state: { Tab: "INQ" },
      });
    } else {
      dispatch(QuestionData({ QuestionDetails: "" }));
      navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", {
        state: { Tab: "INQ" },
      });
    }
  };

  const handleSNSBased = (e) => {
    SetSearchText([]);
    SetNSBased(e);
    localStorage.setItem("IBQF", e);
  };
  const GetsearchQuestion = async () => {
    if (SearchText.length > 0) {
      SetLoad((prev) => !prev);
      await axios
        .get(
          process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetFilterQuestionByQuestionId?QuestionId=${SearchText}&SubjectId=${items?.subjectId}&LanguageId=${SelectLanguage} `,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          SetIBQuestions(res.data);
          SetLoad((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      notify("Please enter the atlest one Question Id", "warning");
    }
  };
  const BacktoNormaList = () => {
    SetSearchText([]);
    localStorage.removeItem("SearchQINQId");
    localStorage.removeItem("SearchSINQId");
    if (NSBased === "NONSCDISQ") {
      GetNONSQuestiuons(CPage);
    } else {
      GetQuestiuons(CPage);
    }
  };
  const SearchByScenarioId = async () => {
    SetLoad((prev) => !prev);
    try {
      const res = await axiosInstance.get(
        `/Scenario/GetInputBasedScenarioByIds?SubjectId=${items?.subjectId}&ScenarioId=${SearchText}&LanguageId=${SelectLanguage}`
      );
      if (res.data[0]?.scenarioID) {
        SetIBQuestions(res.data);
      } else {
        SetIBQuestions(process.env.REACT_APP_NODATAFOUND);
      }
      SetLoad((prev) => !prev);
    } catch (err) {
      SetLoad((prev) => !prev);
      notify("Please enter valid input", "warning");
    }
  };
  const GetFilterDetails = () => {
    if (NSBased === "NONSCDISQ") {
      GetsearchQuestion();
    } else {
      SearchByScenarioId();
    }
  };
  return (
    <>
      {!props.data && <div className="MainHeading">Input based Questions</div>}
      {!props.data && (
        <div className="dflex JCCenter" style={{ gap: "15px" }}>
          {["SCDISQ", "NONSCDISQ"].map((Item) => (
            <div key={Item} className="dflex alignitems" style={{ gap: "5px" }}>
              <input
                type="Radio"
                value={Item}
                name="NSBased"
                checked={NSBased === Item}
                onChange={(e) => handleSNSBased(e.target.value)}
              />{" "}
              {Item === "SCDISQ" ? "Scenario Based" : "Non Scenario Based"}
            </div>
          ))}
        </div>
      )}
      <div className="Card mt-2">
        <div className="dflex JSBetween alignitems InputFIlters m-1">
          <label style={{ backgroundColor: "white" }}>Search</label>

          <div>
            By {NSBased === "NONSCDISQ" ? "Question" : "Scenario"} Id(s){" "}
          </div>

          <Search
            onChange={(e) => SetSearchText(e.replace(/[^0-9,]/g, ""))}
            Searchvalue={SearchText}
            placeholder={`Enter ${NSBased === "NONSCDISQ" ? "Question" : "Scenario"
              } Id(s)`}
          />

          <div className="dflex alignitems gap-2">
            <button className="Buttons" onClick={GetFilterDetails}>
              Go
            </button>

            <button className="Buttons" onClick={BacktoNormaList}>
              Clear Filters
            </button>
          </div>
        </div>
      </div>
      <div className="dflex mt-3 mb-2 alignitems JSBetween">
        <div className="SubHeading">
          {NSBased === "SCDISQ" ? " Scenarios" : "Questions"}
        </div>
       { CheckLanguage(parseInt(SelectLanguage))?.[1] ? <></>:
        <button className="Buttons AddButton dflex alignitems JCCenter" onClick={IBAUQuestions}>
          <HiMiniPlusSmall /> Add{" "}
          {NSBased === "SCDISQ" ? "Scenario" : "Question"}
        </button>}
      </div>
      <div className="Card mt-2">
        {IBQuestions?.[0]?.scenarioID || IBQuestions?.[0]?.questionID ? (
          <DataTable
            data={IBQuestions}
            columns={
              (props.SType || NSBased) === "SCDISQ"
                ? ScenarioBased
                : NONScenarioBased
            }
            className="NCLDataTable"
            TotalRecords={
              (props.SType || NSBased) === "SCDISQ"
                ? IBQuestions[0]?.totalScenario
                : IBQuestions[0]?.totalQuestions
            }
            CountPage={SetPageCount}
            NoPage={CPage}
            tablename={NSBased}
            Dropdownvalues={["10", "25", "50", "100"]}
            ShowPagination="true"
            ShowPagecount="true"
            hitapi={(e) => {
              NSBased === "SCDISQ" ? GetQuestiuons(e) : GetNONSQuestiuons(e);
            }}
          />
        ) : (
          <div className="ErrorMessage">{IBQuestions}</div>
        )}
      </div>
      {DMessage?.open && (
        <div className="Model-Open">
          <div className="Card w-50">
            {" "}
            {DMessage?.message}
            <button
              className="Buttons"
              style={{ float: "right" }}
              onClick={() => {
                SetDMessage({ open: false });
              }}
            >
              ok
            </button>
          </div>
        </div>
      )}
      {StatusData && (
        <ViewVerificationQStatus QId={StatusData} Close={SetStatusData} />
      )}
      {QuestionsData && (
        <ViewQuestionStatus QId={QuestionsData} Close={SetQuestionData} />
      )}
      {Load && <Loading />}
    </>
  );
};
export default InputBasedQuestions;
